var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokerstarsLogoStandalone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.992 11.34C27.986 4.334 23.49 0 23.49 0s-4.455 4.333-11.461 11.34C8.342 15.025 0 24.219 0 33.331c0 6.075 4.941 11.016 11.016 11.016 4.01 0 7.493-2.146 9.396-5.305.203-.243.527-.446.85-.446.567 0 1.094.406 1.013.892-.405 3.28-2.268 11.34-9.558 14.093h21.465c-7.29-2.713-9.113-10.813-9.558-14.094-.081-.486.446-.89 1.013-.89.364 0 .688.202.85.445 1.904 3.159 5.427 5.305 9.396 5.305 6.075 0 11.016-4.94 11.016-11.016.121-9.112-8.181-18.306-11.907-21.991z",
    fill: "#D70A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.53 11.34l2.957 9.194h9.68l-7.817 5.67 2.997 9.193-7.817-5.67-7.816 5.67 2.997-9.194-7.857-5.67h9.68l2.997-9.193z",
    fill: "#fff"
  })));
}
SvgPokerstarsLogoStandalone.displayName = 'PokerstarsLogoStandalone';
export default SvgPokerstarsLogoStandalone;